import { create } from 'zustand';
import { parsePlaces, type PrivatePlace } from '@/core/telemetry/zones';
import { readPreference, writePreference } from '@/lib/preferences';

interface PlacesStore {
  /** Places kept out of every ride: on this device only, never uploaded or put in a recipe. */
  readonly places: readonly PrivatePlace[];
  add(place: Omit<PrivatePlace, 'id'>): void;
  remove(id: string): void;
}

const persist = (places: readonly PrivatePlace[]) => writePreference('places', JSON.stringify(places));

export const usePlacesStore = create<PlacesStore>()((set, get) => ({
  places: parsePlaces(readPreference('places')),
  add(place) {
    // About 1 m of precision is plenty for a zone of a few hundred metres, and stores less.
    const round = (value: number) => Math.round(value * 1e5) / 1e5;
    const places = [...get().places, { id: `place-${Date.now().toString(36)}`, latitude: round(place.latitude), longitude: round(place.longitude) }];
    persist(places);
    set({ places });
  },
  remove(id) {
    const places = get().places.filter((place) => place.id !== id);
    persist(places);
    set({ places });
  },
}));
